module.exports = __webpack_public_path__ + "img/jjyttt.00cf572f.jpg";